import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-limit-reached',
  standalone: true,
  imports: [CommonModule,ButtonModule],
  templateUrl: './limit-reached.component.html',
  styleUrl: './limit-reached.component.css'
})
export class LimitReachedComponent {
  constructor(private router:Router) {}
  retry() {
    this.router.navigate(['/unavailable']);
    console.log('Retry clicked');
  }

}
